module.exports = __webpack_public_path__ + "img/Device-Admin.871cb1d0.png";